export enum CancellationType {
    UNKNOWN = 'UNKNOWN',
    PARTIAL_REFUNDABLE = 'PARTIAL_REFUNDABLE',
    NON_REFUNDABLE = 'NON_REFUNDABLE',
    FREE_CANCELLATION = 'FREE_CANCELLATION',
}
